import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { MaskPipe, NgxMaskModule } from 'ngx-mask';
import { BuildFormComponent } from './components/form/build-component/build-form.component';
import { DatePickerModalComponent } from './components/form/date-picker-modal/date-picker-modal.component';
import { EmptyListModule } from './components/empty-list/empty-list.module';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgxMaskModule.forRoot(),
    IonicModule,
    EmptyListModule
  ],
  declarations: [
    BuildFormComponent,
    DatePickerModalComponent,
  ],
  exports: [
    BuildFormComponent,
  ],
  providers: [
    MaskPipe
  ]
})
export class UiMobileModule { }
